import { AdReviews } from '../types/ad-reviews';

export const UPDATE_AD_REVIEWS = 'UPDATE_AD_REVIEWS';

export const updateAdReviews = (payload: AdReviews) => ({
    type: UPDATE_AD_REVIEWS,
    payload,
});

export default (state = [] as AdReviews, action: ReturnType<typeof updateAdReviews>) =>
    action.type === UPDATE_AD_REVIEWS ? action.payload : state;
